const xls = require('json-as-xlsx');

function exportStats(filename, sheetName, headers, srcData) {
    const columns = headers
        .map(col => {
            return {
                label: col.text,
                value: col.value,
            }
        })
        .filter(obj => obj.value !== 'actions')

    const content = srcData.map(obj => {
        const row = {}

        columns.forEach(col => {
            switch (col.value) {
                default: row[col.value] = obj[col.value]
            }
        })

        return row
    })
    let data = [{
        sheet: sheetName,
        columns: columns,
        content: content
    }]
    let settings = {
        fileName: filename,
    }

    xls(data, settings)
}

function arrSplice(array, spliceOperator) {
    for (let i = 0; i < array.length; i++) {
        let res = spliceOperator(array[i]);
        if (typeof res == 'boolean' && res) {
            array.splice(i, 1);
            return arrSplice(array, spliceOperator);
        }
    }
    return array
}

function arrPopulated(array) {
    return Array.isArray(array) && array.length > 0;
}

function blankString(value) {
    return typeof value === "undefined" || value == null || value === '';
}

function getUUID(){
    var dt = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (dt + Math.random()*16)%16 | 0;
        dt = Math.floor(dt/16);
        return (c=='x' ? r :(r&0x3|0x8)).toString(16);
    });
    return uuid;
}

function objectifyArr(arr, identifier) {
    return arr.reduce((obj, item) => {
        try {
            obj[item[identifier]] = item
        } catch (e) {
            // eslint-disable-next-line
            console.log(e)
        }
        return obj
    }, {})
}

function validateEmail(email) {
    var re = /\S+@\S+\.\S+/;
    return re.test(email);
}

function validateCellNo(number) {
    var re = /(^0\d\d\d\d\d\d\d\d\d$)|(^27\d\d\d\d\d\d\d\d\d$)/;
    return re.test(number);
}

function arrPushMerge(arr, vals, compareKey) {
    vals.forEach(val => {
        let bExists = arr.reduce((exists, obj) => {
            if (!exists) {
                if (blankString(compareKey)) {
                    if (val === obj) {return true}
                } else {
                    if (val[compareKey] === obj[compareKey]) {return true}
                }
            }
            return exists
        }, false);
        if (!bExists) {arr.push(val)}
    });
    return arr;
}

function boolToInt(boolVal) {
    if (boolVal) {
        return 1
    } else {
        return 0
    }
}

function intToBool(intVal) {
    if (intVal == 1) {
        return true
    } else {
        return false
    }
}

function getInitials(str) {
    try {
        let arrNames = str.split(' ');
        return `${arrNames[0].split('').shift()}${arrNames.pop().split('').shift()}`.toUpperCase();
    } catch(e) {
        return 'XX'
    }
}

const EventEmitter = require('events');
let snackEmitter = new EventEmitter();
function showSnack(message) {
    snackEmitter.emit('showSnack', message)
}

const validationRules = {
    required: value => !!value || 'Required Value',
    notZero: value => value === '0' || value === '' || value == null ? 'Value can not be zero' : true,
    notNull: value => value !== null || 'Required Value',
    min6Characters: value => value !== null && value.split('').length >= 6 || 'Minimum 6 characters',
    idNo: value => value !== null && value.split('').length === 13 || '13 characters required',
    fourteenCharacters: value => value !== null && value.split('').length === 14 || 'Code has to be 14 characters long',
    specialCharacter: value => value !== null && /[^A-Za-z0-9]/.test(value) || 'Minimum 1 special character (eg. !@#$%)',
    upperCase: value => value !== null && /[A-Z]/.test(value) || 'Minimum 1 uppercase character',
    lowerCase: value => value !== null && /[a-z]/.test(value) || 'Minimum 1 lowercase character',
    numeric: value => value !== null && /[0-9]+/.test(value) || 'Minimum 1 numerical character',
    numberOnly: value => value !== null && /^[\d\\.]+$/.test(value) || 'Only numbers allowed',
    wholeNumberOnly: value => value !== null && /^[\d]+$/.test(value) || 'Only whole numbers allowed',
    email: value => {
        if (value !== null && value.length > 0) {
            const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return pattern.test(value) || 'Invalid Email Address';
        } else {
            return 'Please enter a valid email address'
        }
    },
    cellNo: value => value !== null && /[0-9+ ][^A-Za-z]{9,}/.test(value) || 'Please enter a valid phone number',
    sqlDateOnly: value => value !== null && /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/gm.test(value) || 'Please enter a valid Date',
}

const dateFormats = {
    longDate: 'EEE do MMMM yyyy h:maaa',
}
const copyText = (documentContext, text) => {
    const node = documentContext.createElement("input");
    node.setAttribute('id', 'copyInput')
    node.setAttribute('value', text)
    documentContext.body.appendChild(node);
    const inputBox = documentContext.getElementById('copyInput');
    inputBox.select();
    documentContext.execCommand("copy");
    navigator.clipboard.writeText(inputBox.value)
    documentContext.body.removeChild(node);
}

function generateRandomId(len = 6) {
    const arr = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9",]
    let str = ''
    while (str.length < len)
        str = str + arr[Math.round(Math.random() * (arr.length - 1))]
    return str;
}

export {
    arrSplice,
    arrPopulated,
    blankString,
    getUUID,
    objectifyArr,
    validateEmail,
    validateCellNo,
    arrPushMerge,
    intToBool,
    boolToInt,
    showSnack,
    getInitials,
    snackEmitter,
    validationRules,
    dateFormats,
    exportStats,
    copyText,
    generateRandomId
}
